import posthog from 'posthog-js';

export function initPostHog() {
    posthog.init('phc_q8pmmRNsSI0bK6oxfFbfr0YZ98su5CU7RagdjBUVF8B', {
        api_host: 'https://app.posthog.com',
        disable_session_recording: false,
        session_recording: {
            // WARNING: Only enable this if you understand the security implications
            recordCrossOriginIframes: true,
            maskAllInputs: false,
            maskInputOptions: {
                password: true,
            },
        },
    });
}

export function usePostHog() {
    return posthog;
}
